/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * TFA API
 * API for TFA
 * OpenAPI spec version: 2.0.0 (api.admin.v1)
 */

/**
 * * `Beginner` - Beginner
* `Intermediate` - Intermediate
* `Advanced` - Advanced
 */
export type SkillLevelEnum = typeof SkillLevelEnum[keyof typeof SkillLevelEnum];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SkillLevelEnum = {
  Beginner: 'Beginner',
  Intermediate: 'Intermediate',
  Advanced: 'Advanced',
} as const;
